import React from 'react';
import LessonContainer from '../LessonContainer';

export default function DocTabContent({
  currentWhiteboard, whiteboardContents, docContainers, editorContents,
  setMainEditor, setActiveEditorHandler, addEditorToMap, setEditorContents,
  isStudent, lessonMode, remote, isFollowMode, isStudentLocked,
  moveDocContainerUp, moveDocContainerDown, deleteDocContainer, addDocContainer,
}) {
  // eslint-disable-next-line no-unused-vars
  const docContent = whiteboardContents[`whiteboard-${currentWhiteboard.id}`] || '';
  const currentDocContainers = docContainers[currentWhiteboard.id] || [];

  // console.log(`Rendering doc ${currentWhiteboard.id} with content:`, docContent);

  return (
    <div style={{ position: 'relative' }}>
      {currentDocContainers.map((container, index) => {
        const containerContent = editorContents[`doc-${currentWhiteboard.id}-container-${container.id}`] || '';
        return (
          <div
            key={container.id}
            // ОТКЛЮЧЕНО: drag and drop атрибуты
            // draggable
            // onDragStart={(e) => handleDragStart(e, container.id)}
            // onDragOver={handleDragOver}
            // onDrop={(e) => handleDrop(e, container.id)}
            // onDragEnd={handleDragEnd}
            // style={{
            //   cursor: 'move',
            //   opacity: draggedContainer === container.id ? 0.5 : 1
            // }}
          >
            <div style={{ position: 'relative' }}>
              <LessonContainer
                id={`doc-${currentWhiteboard.id}-${container.id}`}
                setMainEditor={setMainEditor}
                setActiveEditorId={setActiveEditorHandler}
                addEditorToMap={(editorId, editor) => {
                  addEditorToMap(editorId, editor);
                }}
                initialContent={containerContent}
                onContentChange={(content) => {
                  setEditorContents(prev => ({
                    ...prev,
                    [`doc-${currentWhiteboard.id}-container-${container.id}`]: content
                  }));
                }}
                isStudent={isStudent}
                lessonMode={lessonMode}
                liveContent={isStudent
                  ? (remote?.editorContents?.[`doc-${currentWhiteboard.id}-container-${container.id}`] || null)
                  // Outside Follow Mode, mirror the student's live typing
                  // back to the teacher — see the main container's
                  // liveContent above for the full reasoning.
                  : (!isFollowMode ? (remote?.studentEditorContents?.[`doc-${currentWhiteboard.id}-container-${container.id}`] || null) : null)}
                isStudentLocked={isStudentLocked}
              />
              {/* Кнопки перемещения */}
              <button
                onClick={() => moveDocContainerUp(currentWhiteboard.id, container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Move container up"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 40,
                  width: 25,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'all 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m505.646 388.491c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-218.964-218.964-218.964 218.964c-8.475 8.475-22.208 8.475-30.682 0-8.472-8.47-8.472-22.208 0-30.678l234.305-234.307c8.475-8.47 22.208-8.47 30.682 0l234.305 234.307c8.472 8.47 8.472 22.207 0 30.678z"/>
                </svg>
              </button>
              <button
                onClick={() => moveDocContainerDown(currentWhiteboard.id, container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Move container down"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 67,
                  width: 25,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'all 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m505.646 154.188-234.305 234.303c-4.237 4.237-9.788 6.356-15.341 6.356s-11.104-2.119-15.341-6.356l-234.305-234.303c-8.472-8.472-8.472-22.21 0-30.682 8.475-8.47 22.208-8.47 30.682 0l218.964 218.964 218.964-218.964c8.475-8.47 22.208-8.47 30.682 0 8.472 8.473 8.472 22.21 0 30.682z"/>
                </svg>
              </button>
              {/* Кнопка удаления */}
              <button
                onClick={() => deleteDocContainer(currentWhiteboard.id, container.id)}
                onMouseEnter={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ee5a24';
                }}
                onMouseLeave={(e) => {
                  const svg = e.target.querySelector('svg');
                  if (svg) svg.style.fill = '#ccc';
                }}
                title="Delete container"
                style={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  width: 21,
                  height: 25,
                  background: 'transparent',
                  border: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 18,
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'color 0.2s ease'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 512 512" fill="#ccc" xmlns="http://www.w3.org/2000/svg">
                  <path d="m8.1 503.9c5.4 5.4 12.4 8.1 19.4 8.1s14-2.7 19.4-8.1l209.1-208.8 208.8 208.8c5.4 5.4 12.4 8.1 19.4 8.1s14-2.7 19.4-8.1c10.8-10.8 10.8-28.3 0-39.1l-208.5-208.8 208.8-208.8c10.8-10.8 10.8-28.3 0-39.1s-28.3-10.8-39.1 0l-208.8 208.8-208.8-208.8c-10.8-10.8-28.3-10.8-39.1 0s-10.8 28.3 0 39.1l208.8 208.8-208.8 208.8c-10.8 10.8-10.8 28.3 0 39.1z"/>
                </svg>
              </button>
            </div>
            {index === currentDocContainers.length - 1 && (
              <button
                onClick={() => addDocContainer(currentWhiteboard.id)}
                className="add-container-button"
              >
                +
              </button>
            )}
          </div>
        );
      })}
      {/* Показываем кнопку добавления если нет контейнеров */}
      {currentDocContainers.length === 0 && (
        <button
          onClick={() => addDocContainer(currentWhiteboard.id)}
          className="add-container-button"
          style={{ position: 'relative', top: '50px' }}
        >
          +
        </button>
      )}
    </div>
  );
}
